// extracted by mini-css-extract-plugin
var _1 = "pfx-CommunityWriteComment-module__avatar-and-input--brXhw";
var _2 = "#000";
var _3 = "1260px";
var _4 = "1020px";
var _5 = "668px";
var _6 = "1550px";
var _7 = "pfx-CommunityWriteComment-module__button--R7cfk";
var _8 = "pfx-CommunityWriteComment-module__container--MS1qs";
var _9 = "1140px";
var _a = "940px";
var _b = "100%";
var _c = "15px";
var _d = "620px";
var _e = "#f53535";
var _f = "rgba(0,0,0,.2)";
var _10 = "rgba(255,255,255,.38)";
var _11 = ".38";
var _12 = "rgba(255,255,255,.2)";
var _13 = "#0025ff";
var _14 = "pfx-CommunityWriteComment-module__glitch-anim--IPn3p";
var _15 = "pfx-CommunityWriteComment-module__glitch-anim-2--_i_Em";
var _16 = "#f60";
var _17 = "#41ead4";
var _18 = "#2cdd78";
var _19 = "#66ab23";
var _1a = "#f5f5f5";
var _1b = "#c3c3c3";
var _1c = "#ececec";
var _1d = "#252525";
var _1e = "#272727";
var _1f = "#c6c6c5";
var _20 = "#333";
var _21 = "#3c3c3c";
var _22 = "#9c9b9b";
var _23 = "#8c8c8c";
var _24 = "#6f6f6e";
var _25 = "#3c3c3b";
var _26 = "#373737";
var _27 = "#6a6a69";
var _28 = "#6f6f6f";
var _29 = "#9f9e9e";
var _2a = "#282828";
var _2b = "#828181";
var _2c = "#1d1d1d";
var _2d = "#979797";
var _2e = "#9c9b9b";
var _2f = "#a7a7a6";
var _30 = "#c6c6c5";
var _31 = "#d8d8d7";
var _32 = "#dddddc";
var _33 = "72px";
var _34 = "40px";
var _35 = "36px";
var _36 = "25px";
var _37 = "18px";
var _38 = "13px";
var _39 = "pfx-CommunityWriteComment-module__img--lV7v7";
var _3a = "#0025ff";
var _3b = "rgba(255,255,255,.12)";
var _3c = "#6535f5";
var _3d = "pfx-CommunityWriteComment-module__login--rjwh7";
var _3e = "2px";
var _3f = "56px";
var _40 = "56px";
var _41 = "#41ead4";
var _42 = "#f60";
var _43 = "#f83600";
var _44 = "#881f00";
var _45 = "18px";
var _46 = "15px";
var _47 = "pfx-CommunityWriteComment-module__pfx-double-bounce1--Re5v1";
var _48 = "pfx-CommunityWriteComment-module__pfx-double-bounce2--FvE4d";
var _49 = "pfx-CommunityWriteComment-module__pfx-icon--Rtr3B";
var _4a = "pfx-CommunityWriteComment-module__pfx-linkton--edLv6";
var _4b = "pfx-CommunityWriteComment-module__pfx-linkton__child-wrapper--Lkfeo";
var _4c = "pfx-CommunityWriteComment-module__pfx-linkton__child-wrapper--with-icon--_Psk7";
var _4d = "pfx-CommunityWriteComment-module__pfx-linkton__child-wrapper--with-only-icon--sSd4S";
var _4e = "pfx-CommunityWriteComment-module__pfx-linkton--color-black--rXaFL";
var _4f = "pfx-CommunityWriteComment-module__pfx-linkton--color-danger--jDONn";
var _50 = "pfx-CommunityWriteComment-module__pfx-linkton--color-grey--tLS0D";
var _51 = "pfx-CommunityWriteComment-module__pfx-linkton--color-klein--qY_G2";
var _52 = "pfx-CommunityWriteComment-module__pfx-linkton--color-klein_white--prtuw";
var _53 = "pfx-CommunityWriteComment-module__pfx-linkton--color-light--d4Fdt";
var _54 = "pfx-CommunityWriteComment-module__pfx-linkton--color-ocean--JqHLH";
var _55 = "pfx-CommunityWriteComment-module__pfx-linkton--color-primary--lp9UQ";
var _56 = "pfx-CommunityWriteComment-module__pfx-linkton--color-secondary--48_WH";
var _57 = "pfx-CommunityWriteComment-module__pfx-linkton--color-secondary_light--ejXL0";
var _58 = "pfx-CommunityWriteComment-module__pfx-linkton--color-white--ExF_H";
var _59 = "pfx-CommunityWriteComment-module__pfx-linkton--color-yellow--qQkC_";
var _5a = "pfx-CommunityWriteComment-module__pfx-linkton--disabled--fgnw2";
var _5b = "pfx-CommunityWriteComment-module__pfx-linkton--hover-color--vTG8d";
var _5c = "pfx-CommunityWriteComment-module__pfx-linkton--hover-glitch--ap7Fg";
var _5d = "pfx-CommunityWriteComment-module__pfx-linkton--hover-none--vasH9";
var _5e = "pfx-CommunityWriteComment-module__pfx-linkton--hover-outline--NHoPl";
var _5f = "pfx-CommunityWriteComment-module__pfx-linkton--hover-transparency--JH_ib";
var _60 = "pfx-CommunityWriteComment-module__pfx-linkton--hover-underscore--HKYXi";
var _61 = "pfx-CommunityWriteComment-module__pfx-linkton__icon--Lopub";
var _62 = "pfx-CommunityWriteComment-module__pfx-linkton__icon--alone--MwoDB";
var _63 = "pfx-CommunityWriteComment-module__pfx-linkton__icon--left--d9Bj2";
var _64 = "pfx-CommunityWriteComment-module__pfx-linkton--loading--Z6z0E";
var _65 = "pfx-CommunityWriteComment-module__pfx-linkton--padding-0--z8N_F";
var _66 = "pfx-CommunityWriteComment-module__pfx-linkton--padding-100--wBd9I";
var _67 = "pfx-CommunityWriteComment-module__pfx-linkton--padding-125--TR6bP";
var _68 = "pfx-CommunityWriteComment-module__pfx-linkton--padding-150--VoaMT";
var _69 = "pfx-CommunityWriteComment-module__pfx-linkton--padding-25--_waDH";
var _6a = "pfx-CommunityWriteComment-module__pfx-linkton--padding-50--x2Qyp";
var _6b = "pfx-CommunityWriteComment-module__pfx-linkton--padding-75--i__SQ";
var _6c = "pfx-CommunityWriteComment-module__pfx-linkton--padding-large--JJVi5";
var _6d = "pfx-CommunityWriteComment-module__pfx-linkton--padding-medium--vYuqo";
var _6e = "pfx-CommunityWriteComment-module__pfx-linkton--padding-medium-small--il_oy";
var _6f = "pfx-CommunityWriteComment-module__pfx-linkton--padding-small--eSbF3";
var _70 = "pfx-CommunityWriteComment-module__pfx-linkton--responsive--mtaUE";
var _71 = "pfx-CommunityWriteComment-module__pfx-linkton--size-10--Xz1qO";
var _72 = "pfx-CommunityWriteComment-module__pfx-linkton--size-11--t5snM";
var _73 = "pfx-CommunityWriteComment-module__pfx-linkton--size-12--4DK6Y";
var _74 = "pfx-CommunityWriteComment-module__pfx-linkton--size-13--BDRYd";
var _75 = "pfx-CommunityWriteComment-module__pfx-linkton--size-14--mO8lk";
var _76 = "pfx-CommunityWriteComment-module__pfx-linkton--size-15--V9W_c";
var _77 = "pfx-CommunityWriteComment-module__pfx-linkton--size-16--sUW5J";
var _78 = "pfx-CommunityWriteComment-module__pfx-linkton--size-17--o9Eox";
var _79 = "pfx-CommunityWriteComment-module__pfx-linkton--size-18--Pb_u4";
var _7a = "pfx-CommunityWriteComment-module__pfx-linkton--size-19--ZySuN";
var _7b = "pfx-CommunityWriteComment-module__pfx-linkton--size-20--DaD6D";
var _7c = "pfx-CommunityWriteComment-module__pfx-linkton--size-8--u2MVo";
var _7d = "pfx-CommunityWriteComment-module__pfx-linkton--size-9--DMfga";
var _7e = "pfx-CommunityWriteComment-module__pfx-linkton--size-extra_large--QHoi_";
var _7f = "pfx-CommunityWriteComment-module__pfx-linkton--size-large--xreWw";
var _80 = "pfx-CommunityWriteComment-module__pfx-linkton--size-medium--SctpM";
var _81 = "pfx-CommunityWriteComment-module__pfx-linkton--size-small--Pn8iO";
var _82 = "pfx-CommunityWriteComment-module__pfx-linkton__spinner--pxUdp";
var _83 = "pfx-CommunityWriteComment-module__pfx-linkton--type-full--xIyzH";
var _84 = "pfx-CommunityWriteComment-module__pfx-linkton--type-hollow--pLkiV";
var _85 = "pfx-CommunityWriteComment-module__pfx-linkton--type-outline--iLbNT";
var _86 = "pfx-CommunityWriteComment-module__pfx-linkton--type-tertiary--nAqXI";
var _87 = "pfx-CommunityWriteComment-module__pfx-linkton--type-underlined_link--M3PCq";
var _88 = "pfx-CommunityWriteComment-module__pfx-spinner--N2bPW";
var _89 = "red";
var _8a = "pfx-CommunityWriteComment-module__sk-bounce--sBYPA";
var _8b = "13px";
var _8c = "pfx-CommunityWriteComment-module__submit--WAcMF";
var _8d = "pfx-CommunityWriteComment-module__submit-cta--n3zG9";
var _8e = "rgba(255,255,255,.07)";
var _8f = "pfx-CommunityWriteComment-module__textarea--DntX3";
var _90 = "#35465c";
var _91 = "#55acee";
var _92 = "#fff";
var _93 = "#ffce36";
var _94 = "#ffcd00";
var _95 = "red";
export { _1 as "avatarAndInput", _2 as "black", _3 as "breakLarge", _4 as "breakMedium", _5 as "breakSmall", _6 as "breakVLarge", _7 as "button", _8 as "container", _9 as "containerLarge", _a as "containerMedium", _b as "containerMobile", _c as "containerPaddingMobile", _d as "containerSmall", _e as "danger", _f as "darkElement", _10 as "disabled", _11 as "disabledOpacity", _12 as "extraLightElement", _13 as "facebook", _14 as "glitchAnim", _15 as "glitchAnim2", _16 as "google", _17 as "green", _18 as "green2", _19 as "greenColor", _1a as "grey1", _1b as "grey10", _1c as "grey2", _1d as "grey25", _1e as "grey27", _1f as "grey3", _20 as "grey33", _21 as "grey3C", _22 as "grey4", _23 as "grey41", _24 as "grey5", _25 as "grey6", _26 as "grey61", _27 as "grey6A", _28 as "grey6F", _29 as "grey7", _2a as "grey8", _2b as "grey82", _2c as "grey9", _2d as "grey97", _2e as "grey9C", _2f as "greyA7", _30 as "greyC6", _31 as "greyD8", _32 as "greyDd", _33 as "header1", _34 as "header2", _35 as "header3", _36 as "header4", _37 as "header5", _38 as "header6", _39 as "img", _3a as "klein", _3b as "lightElement", _3c as "lilac", _3d as "login", _3e as "menuBorder", _3f as "menuHeight", _40 as "menuMobileHeight", _41 as "ocean", _42 as "orange", _43 as "orange2", _44 as "orangeDark", _45 as "paragraph", _46 as "paragraphSmall", _47 as "pfxDoubleBounce1", _48 as "pfxDoubleBounce2", _49 as "pfxIcon", _4a as "pfxLinkton", _4b as "pfxLinktonChildWrapper", _4c as "pfxLinktonChildWrapperWithIcon", _4d as "pfxLinktonChildWrapperWithOnlyIcon", _4e as "pfxLinktonColorBlack", _4f as "pfxLinktonColorDanger", _50 as "pfxLinktonColorGrey", _51 as "pfxLinktonColorKlein", _52 as "pfxLinktonColorKleinWhite", _53 as "pfxLinktonColorLight", _54 as "pfxLinktonColorOcean", _55 as "pfxLinktonColorPrimary", _56 as "pfxLinktonColorSecondary", _57 as "pfxLinktonColorSecondaryLight", _58 as "pfxLinktonColorWhite", _59 as "pfxLinktonColorYellow", _5a as "pfxLinktonDisabled", _5b as "pfxLinktonHoverColor", _5c as "pfxLinktonHoverGlitch", _5d as "pfxLinktonHoverNone", _5e as "pfxLinktonHoverOutline", _5f as "pfxLinktonHoverTransparency", _60 as "pfxLinktonHoverUnderscore", _61 as "pfxLinktonIcon", _62 as "pfxLinktonIconAlone", _63 as "pfxLinktonIconLeft", _64 as "pfxLinktonLoading", _65 as "pfxLinktonPadding0", _66 as "pfxLinktonPadding100", _67 as "pfxLinktonPadding125", _68 as "pfxLinktonPadding150", _69 as "pfxLinktonPadding25", _6a as "pfxLinktonPadding50", _6b as "pfxLinktonPadding75", _6c as "pfxLinktonPaddingLarge", _6d as "pfxLinktonPaddingMedium", _6e as "pfxLinktonPaddingMediumSmall", _6f as "pfxLinktonPaddingSmall", _70 as "pfxLinktonResponsive", _71 as "pfxLinktonSize10", _72 as "pfxLinktonSize11", _73 as "pfxLinktonSize12", _74 as "pfxLinktonSize13", _75 as "pfxLinktonSize14", _76 as "pfxLinktonSize15", _77 as "pfxLinktonSize16", _78 as "pfxLinktonSize17", _79 as "pfxLinktonSize18", _7a as "pfxLinktonSize19", _7b as "pfxLinktonSize20", _7c as "pfxLinktonSize8", _7d as "pfxLinktonSize9", _7e as "pfxLinktonSizeExtraLarge", _7f as "pfxLinktonSizeLarge", _80 as "pfxLinktonSizeMedium", _81 as "pfxLinktonSizeSmall", _82 as "pfxLinktonSpinner", _83 as "pfxLinktonTypeFull", _84 as "pfxLinktonTypeHollow", _85 as "pfxLinktonTypeOutline", _86 as "pfxLinktonTypeTertiary", _87 as "pfxLinktonTypeUnderlinedLink", _88 as "pfxSpinner", _89 as "red", _8a as "skBounce", _8b as "subHeaderSmall", _8c as "submit", _8d as "submitCta", _8e as "subtleLightElement", _8f as "textarea", _90 as "tumblr", _91 as "twitter", _92 as "white", _93 as "yellow", _94 as "yellowDeep", _95 as "youtube" }
